
class HandApplyOption {
  Quantity: number = 0;
  IsAvailable: boolean = false;
  UnavailableReason: string = '';
  constructor(rawItem: any) {
    this.Quantity = rawItem.Item1;
    this.IsAvailable = rawItem.Item2;
    this.UnavailableReason = rawItem.Item3;
  }
}
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { OrderlineDetails } from '@/store/models/OrderlineModel';
import { ConversionHelper } from '@/helpers/ConversionHelper';
import { RequestedOrderlineMetricTypes } from '@/ConstValues';
import { OrdersService } from '@/services/orders-service';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { watch } from 'vue';
@Component({
  components: {}
})
export default class HandAppliedMaxRolls extends Vue {
  $refs!: {};
  /* Properties */
  @Prop({ required: true })
  orderline!: OrderlineDetails;
  /* Data */
  handApplyOptions: HandApplyOption[] = [];
  rollQuantityOptions: string[] = ['Off'];
  selectedRollQuantity: number | string = 'Off';
  isLoading = false;

  /* Methods */
  @Watch('orderline')
  async onOrderlineChanged() {
    await this.Initialize();
  }

  get isValid() {
    return (
      this.selectedRollQuantity == 0 ||
      this.handApplyOptions[(this.selectedRollQuantity as number) - 1]?.IsAvailable
    );
  }

  get selectedRollQuantityFormatted(): number | string {
    return this.rollQuantityOptions[this.selectedRollQuantity];
  }
  buildRollQuantityOptions() {
    this.rollQuantityOptions.push(...this.handApplyOptions.map(h => h.Quantity.toString()));
  }

  @Watch('selectedRollQuantity')
  onValueChange() {
    const rollQty = Number(this.selectedRollQuantityFormatted);
    const result = {
      Rolls: rollQty,
      Labels: this.orderline.Quantity / rollQty
    };
    this.$emit('can-submit', this.isValid);
    this.$emit('roll-quantity', result);
  }

  async GetAvailableRollQuantities() {
    try {
      let model = {
        OrderlineToEdit: ConversionHelper.convertOrderlineToAddModel(this.orderline),
        RequestedValueToChange: RequestedOrderlineMetricTypes.RollQuantity
      };
      const { data } = await OrdersService.CalculateExpectedRollSpecifications(model);
      this.handApplyOptions = data.AvailableRollQuantities.map(d => new HandApplyOption(d));
      this.buildRollQuantityOptions();
    } catch (err) {
      SetSnackBar(
        'Error has occured, please contact techsupport@just1label.com if you are experiencing any issues'
      );
    }
  }
  resetDefaultValues() {
    this.rollQuantityOptions = ['Off'];
    this.selectedRollQuantity = 'Off';
  }
  async Initialize() {
    this.isLoading = true;
    this.resetDefaultValues();
    await this.GetAvailableRollQuantities();
    if (this.orderline.IsHandApply)
      this.selectedRollQuantity = this.rollQuantityOptions.findIndex(
        r => parseInt(r) === this.orderline.RequestedRollQuantity
      );
    this.isLoading = false;
  }
  /* Mounted */
  async mounted() {
    await this.Initialize();
  }
  /* Created */
}
